import React, { useState, useEffect, useRef } from 'react';
import axios from 'store/axios/axios-crm';
import propertyFields from './PropertiesObj';
import { importerFields } from './PropertiesObj';
import {
    min1, min2, min6, min4, min5, min10, email, required, no_letters, no_special_chars, no_numbers,
    max4, max10, max15, max50, max100, max250, max500
} from "shared/validation";
import { handleError } from '../../../shared/utility';
const validate = {
    min1, min2, min6, min4, min5, min10, email, required, no_letters, no_special_chars, no_numbers,
    max4, max10, max15, max50, max100, max250, max500
}
const getValidations = (f, val) => {
    if (!propertyFields[f]) return 
    if (!propertyFields[f].validations) return null;
    const validations = propertyFields[f].validations.map(v => {
        return validate[v];
    });
    const errors = validations.map(v => {
        if (!v) return null;
        const result = v(val);
        if (result) return result;
        return null;
    }).filter(v => {
        if (!v) return false;
        return true;
    });
    if (errors.length > 0) return errors.join(', ');
    return '';
}

const arrayHasNumber = (arr) => {
    let hasNumber = false;
    arr.forEach(a => {
        if (a) {
            if (!isNaN(a)) {
                hasNumber = true;
            }
        }
    })
    return hasNumber
}

export const getErrors = (dataObj, others, theContactData) => {
    const { leasesForAdd, listingsForAdd, meetingsForAdd, offersForAdd, showingsForAdd } = others;
    
    
    let errors = {};
    Object.keys(propertyFields).forEach(field => {
        if (propertyFields[field].validations) {
            const hasError = getValidations(field, dataObj[field]);
            if (hasError) errors[field] = hasError;
        }
    })

    // prevent submission if Street1 has "-" e.g. "123 - 125 Astor Drive" 
    if (dataObj.street1 && dataObj.address_is_range === 'Yes') {
        const street1_arr1 = dataObj.street1.split('-');
        const street1_arr2 = dataObj.street1.split('- ');
        const street1_arr3 = dataObj.street1.split(' - ');
        const error_message = 'Address should not have a dash with numbers before and/or after it (Signifying Address Range)';
        if (street1_arr1.length > 0) {
            if (arrayHasNumber(street1_arr1)) errors.street1 = error_message;
        }
        if (street1_arr2.length > 0) {
            if (arrayHasNumber(street1_arr2)) errors.street1 = error_message;
        }
        if (street1_arr3.length > 0) {
            if (arrayHasNumber(street1_arr3)) errors.street1 = error_message;
        }
    }
    // prevent submission if Street2 has "-" e.g. "123 - 125 Astor Drive" 
    if (dataObj.street2 && dataObj.address_is_range === 'Yes') {
        const street2_arr1 = dataObj.street2.split('-');
        const street2_arr2 = dataObj.street2.split('- ');
        const street2_arr3 = dataObj.street2.split(' - ');
        const error_message = 'Address should not have a dash with numbers before and/or after it (Signifying Address Range)';
        if (street2_arr1.length > 0) {
            if (arrayHasNumber(street2_arr1)) errors.street2 = error_message;
        }
        if (street2_arr2.length > 0) {
            if (arrayHasNumber(street2_arr2)) errors.street2 = error_message;
        }
        if (street2_arr3.length > 0) {
            if (arrayHasNumber(street2_arr3)) errors.street2 = error_message;
        }
    }
    // require address range if is_address_range === 'Yes'
    if (dataObj.address_is_range === 'Yes') {
        if (!dataObj.street_range1 || !dataObj.street_range2) {
            errors.street1 = 'Street Ranges are required if "Is Address Range" is set to Yes';
        }
        function isValidInput(str) {
            return /^[0-9\/\\ +-]*$/.test(str);
        }
        if (dataObj.street_range1 && dataObj.street_range2) {
            const r1 = dataObj.street_range1;
            const r2 = dataObj.street_range2;
            
            if (!isValidInput(r1) || !isValidInput(r2)) {
                errors.street1 = 'Street Ranges must be numbers only and /';
            }
        }
    }
    
    if (Object.keys(errors).length > 0) return errors;
    return null;
}

export const useSaveProperties = (props) => {
    const { madeChanges, dataObj, action, updateProperty, theContactData,
    leasesForAdd, listingsForAdd, meetingsForAdd, offersForAdd, showingsForAdd,
    isAutoSave, setIsAutoSave, success, setMadeChanges } = props;

    const [errorData, setErrorData] = useState(null);

    const others = {
        leasesForAdd, listingsForAdd, meetingsForAdd, offersForAdd, showingsForAdd
    };

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
            ref.current = value;
        });
        return ref.current;
    }

    const prevSuccess = usePrevious(success);

    useEffect(() => {
        if (success && prevSuccess !== success) {
            if (success.indexOf('Success') !== -1) {
                setIsAutoSave(false);
            }
        }
    }, [success]);

    const TIME = 300000;

    useEffect(() => {
        const interval = setInterval(() => {
            if(madeChanges) {
                const errors = getErrors(dataObj, others, theContactData);
                setErrorData(errors);
                if (!errors) {
                    const newObj = { ...dataObj };
                    if (newObj.illi_represented === '1') {
                        newObj.illi_represented = 1;
                    } else if (newObj.illi_represented === '0') {
                        newObj.illi_represented = 0;
                    } else {
                        delete newObj.illi_represented;
                    }
                    if (action === 'Edit') {
                        setIsAutoSave(true);
                        updateProperty(newObj);
                        setMadeChanges(false);
                    }
                }
            }
        }, TIME);
        return () => clearInterval(interval);
    }, [madeChanges, dataObj]);
}

const checkProperty = (existingData, newData) => {
	let exists = false;
	let different = false;
	if (newData && existingData) {
		exists = true;
		if (newData != existingData) {
			different = true;
		}
	}
	return {
		exists, different
	}
}

export const fieldsForAnalyzing = [
    'illi_number',
    'pm_number',
    'name',
    'street_range1',
    'street_range2',
    'street1',

    'street2_range1',
    'street2_range2',
    'street2',
    'city',
    'state',
    'zip',

    'use_type',
    'total_building_sqft',
    'property_is_for',
];

export const createAfterProperty = (d) => {
    const exists = (dat) => {
        return dat ? dat : '';
    }
    const fields = fieldsForAnalyzing;
    const after_property = {};
    fields.forEach(field => {
        after_property[field] = exists(d[importerFields.indexOf(field)]);
    });
    return after_property;
}

export const analyzeDiffs = (existing_property, after_property) => {
    let existing_fields = [];
    let different_fields = [];
    const fields = fieldsForAnalyzing;
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const check = checkProperty(existing_property[field], after_property[field]);
        if (check.different) different_fields.push({
            field,
            value: after_property[field]
        });
        if (check.exists) existing_fields.push({
            field,
            value: existing_property[field]
        });
    }
    return {
        existing_fields,
        different_fields
    }
}

export const analyzeImportData = (checks, after_property) => {
    let hasIssues = false;
    if (checks.found_properties) {
        if (checks.found_properties.length > 0) {
            hasIssues = true;
            // if (checks.found_properties.length > 0) {
            //     // filter found properties
            //     hasIssues = true;
            // } else {
            //     const existing_property = checks.found_properties[0];
            //     // analyze if there are differences
            //     const analyzed = analyzeDiffs(existing_property, after_property);
            //     if (analyzed.different_fields.length > 0) {
            //         hasIssues = true;
            //     }
            // }
        }
    }
    return hasIssues;
}

export const createAddressObject = (property) => {
    console.log('propertyobject', property);
    // used to create a normal address1, address2, city, state, zip object
    const obj =  {
        name: property.name ? property.name : '',
        street1: property.street1 ? property.street1 : '',
        street2: property.street2 ? property.street2 : '',
        city: property.city ? property.city : '',
        state: property.state ? property.state : '',
        zip: property.zip ? property.zip : ''
    };
    if (property.address_is_range === 'Yes') {
        const range = (property.street_range1 && property.street_range2) ? 
            `${property.street_range1}-${property.street_range2}` : ``;
        obj.street1 = `${range ? range + ' ' : ''}${property.street1}`;
    }
    if (property.address2_is_range === 'Yes') {
        const range = (property.street2_range1 && property.street2_range2) ? 
            `${property.street2_range1}-${property.street2_range2}` : ``;
        obj.street2 = `${range ? range + ' ' : ''}${property.street2}`;
    }
    return obj;
}

export const getPropertyPermissions = (propertyShares, dataObj, user_id, action, permsObj) => {
    console.log('pp->>', propertyShares, dataObj, user_id, action, permsObj);
	if (user_id === dataObj.user_id) return true;
	let result = false;
	if (propertyShares) {
		if (propertyShares.length > 0) {
			for (let i = 0; i < propertyShares.length; i++) {
				const cs = propertyShares[i];
				if (cs.user_id === user_id) {
					if (cs.access === "F") {
						if (action === "delete") return true;
						if (action === "edit") return true;
					}
					if (cs.access === "E") {
						if (action === "edit") return true;
					}
				}
			}
		}
	}
    if (permsObj) {
		if (permsObj.permObj) {
			if (permsObj.permObj.hasOwnProperty('CRM agent_access_illi_db_full')) {
				return true;
			}
		}
	}
	return result;
};

export const property_is_dict = {
    'Tenant Rep': 'TR',
    'No Listing': 'NL',
    'Property Management': '9',
    'Prospective Listing': '',
    'Consulting': 'C',
    'Buyer Represented': 'BR',
    'Referral': 'R'
}

export const getPropertyFiles = async (property_id) => {
    let files = [];
    try {
        const response = await axios.get('/property?id='+property_id);
        const data = response.data;
        console.log('files received', data);
        // files
        if (data.files) {
            data.files.forEach(df => {
                if (df.filename) {
                    const arr = df.filename.split(',');
                    files.push(arr[1]);
                }
            })
        }
        // featured image file 
        if (data.featured_image_file) {
            const image_arr = data.featured_image_file.split(',');
            if (image_arr[1]) {
                files.push(image_arr[1]);
            }
        }
        // additional images 
        if (data.additional_image_files) {
            const image_arr = JSON.parse(data.additional_image_files);
            console.log('image_arr', image_arr);
            image_arr.forEach(ia => {
                const ia_arr = ia.file.split(',');
                if (ia_arr[1]) {
                    files.push(ia_arr[1]);
                }
            })
        }
    } catch(e) {
        handleError(e);
    }
    return files;
}

export const addPropertyFile = async (property_id, filename) => {
    // adds to Property.files 
    // example : 
    // [
        // {
        //     "filename": "16,Spousal ID-1696293262.png,05/15/2025",
        //     "description": ""
        // }
    // ]
    try {
        const response = await axios.get('/property?id='+property_id);
        const data = response.data;
        console.log('files received', data);
        // files
        const obj = {
                "filename": filename,
                "description": ""
            };
        let found = false;
        if (data.files) {
            // look for existing files. 
            data.files.forEach(file => {
                const true_filename = filename.split(',')[1];
                if (file.filename.indexOf(true_filename) !== -1) {
                    found = true;
                }
            })
            data.files = JSON.stringify(data.files.concat([obj]));
        } else {
            data.files = JSON.stringify([obj]);
        }
        if (!found) {
            await axios.put('/property', {
                id: property_id,
                files: data.files
            })
        }
    } catch(e) {
        handleError(e);
    }
}

export const checkSpacesPermission = (args) => {
    // checks if 
    let pass = false;
    const { user, property } = args;
    if (user) {
        if (user.type === 'E') {
            pass = true;
        } else {
            // ASSOCIATE 
            const permObj = user.permObj;
            // check if property is own 
            console.log('checking space permission', user, property);
            if (property.user_id === user.id) {
                pass = true;
            } else {
                if (permObj) {
                    if (permObj.hasOwnProperty('CRM edit_property_spaces')) {
                        pass = true;
                    }
                }
            }
        }
    }
    return pass;
}
